import {Module} from 'vuex'
import RootStateTypes from '../../interface'
import TestMouduleTypes from './interface'

const testModel:Module<TestMouduleTypes,RootStateTypes>={
    namespaced:true,
    state:{
        name:'test-module',
        count:0,
    },
    mutations:{
        ADD_COUNT(state){
            state.count+=1;
        },
        ADD_COUNT2(state,str:string){
            state.count+=1;
        }
    },
    actions:{
        ADD_COUNT(context: any){
            context.commit('ADD_COUNT')
        }
    }
}
export default testModel;